module.exports = "./assets/assets/相关政策依据.5f12f0ff.doc";